<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section"><strong class="bold">THE APRIL DEAD</strong></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// the-april-dead_00001.vue?084bcd05